import { render, staticRenderFns } from "./UnsubscribeCustomer.vue?vue&type=template&id=42980d16"
import script from "./UnsubscribeCustomer.vue?vue&type=script&lang=js"
export * from "./UnsubscribeCustomer.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeCustomer.vue?vue&type=style&index=0&id=42980d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports